"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DefaultTextField = _interopRequireDefault(require("./DefaultTextField"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Portal = _interopRequireDefault(require("@material-ui/core/Portal"));

var _reactPopper = require("react-popper");

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _defineStyles = require("@sift/skipper/styles/defineStyles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = (0, _defineStyles.defineStyles)(function (theme) {
  return {
    suggestionsPaper: {
      width: '100%',
      minWidth: 300
    },
    suggestionsContainerOpen: {
      maxHeight: 'calc(100% - 52px)',
      overflowY: 'auto'
    }
  };
});

var withPopper = function withPopper(Component) {
  /**
   * An Autosuggest configured with sane defaults and Popper. This component
   * is best used when the UI requires an Autosuggest that respects a parent
   * containers overflow: hidden style.
   */
  var WithPopper = /*#__PURE__*/function (_React$Component) {
    _inherits(WithPopper, _React$Component);

    var _super = _createSuper(WithPopper);

    function WithPopper() {
      var _this;

      _classCallCheck(this, WithPopper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "renderInputComponent", function (inputProps) {
        var renderInputComponent = _this.props.renderInputComponent;
        return /*#__PURE__*/_react["default"].createElement(_reactPopper.Target, null, renderInputComponent ? renderInputComponent(inputProps) : (0, _DefaultTextField["default"])(inputProps));
      });

      _defineProperty(_assertThisInitialized(_this), "renderSuggestionsContainer", function (options) {
        var _this$props = _this.props,
            renderSuggestionsContainer = _this$props.renderSuggestionsContainer,
            classes = _this$props.classes,
            popperProps = _this$props.popperProps,
            containerProps = _this$props.containerProps;
        return /*#__PURE__*/_react["default"].createElement(_Portal["default"], null, /*#__PURE__*/_react["default"].createElement(_reactPopper.Popper, _extends({
          placement: "bottom-start",
          modifiers: {
            flip: {
              enabled: false
            },
            preventOverflow: {
              enabled: false
            },
            hide: {
              enabled: false
            }
          }
        }, popperProps), renderSuggestionsContainer ? renderSuggestionsContainer(options) : /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
          elevation: 2,
          className: classes.suggestionsPaper
        }, /*#__PURE__*/_react["default"].createElement("div", _extends({}, options.containerProps, containerProps), options.children))));
      });

      return _this;
    }

    _createClass(WithPopper, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            classes = _this$props2.classes,
            theme = _this$props2.theme,
            other = _objectWithoutProperties(_this$props2, ["classes", "theme"]);

        return /*#__PURE__*/_react["default"].createElement(_reactPopper.Manager, null, /*#__PURE__*/_react["default"].createElement(Component, _extends({
          theme: _objectSpread({
            suggestionsContainerOpen: classes.suggestionsContainerOpen
          }, theme)
        }, other, {
          renderInputComponent: this.renderInputComponent,
          renderSuggestionsContainer: this.renderSuggestionsContainer
        })));
      }
    }]);

    return WithPopper;
  }(_react["default"].Component);

  _defineProperty(WithPopper, "propTypes", {
    theme: _propTypes["default"].object.isRequired,
    popperProps: _propTypes["default"].object,
    containerProps: _propTypes["default"].object,
    renderInputComponent: _propTypes["default"].func,
    renderSuggestionsContainer: _propTypes["default"].func,
    classes: _propTypes["default"].object.isRequired
  });

  return (0, _withStyles["default"])(styles, {
    withTheme: true
  })(WithPopper);
};

var _default = withPopper;
exports["default"] = _default;